import axiosInstance from "./axiosInstance";
import {CreatePostTypeMultiple} from "../types/ComponentProps";

const createPost = async (formData: CreatePostTypeMultiple) => {
  const accessToken = localStorage.getItem("accessTokenGC");

  const handleEmptyArrays = (data: any) =>
    Array.isArray(data) && data.length === 0 ? null : data;

  formData.recipients = handleEmptyArrays(formData.recipients);
  formData.hashTagIds = handleEmptyArrays(formData.hashTagIds);
  formData.imagePost = handleEmptyArrays(formData.imagePost);
  formData.badges = handleEmptyArrays(formData.badges);

  const postData = new FormData();
  postData.append("message", formData.message);
  postData.append("pointsGiven", String(formData.pointsGiven || 0));
  postData.append("coinsGiven", String(formData.coinsGiven || 0));

  if (formData.recipients) {
    postData.append("recipients", JSON.stringify(formData.recipients));
  }

  if (formData.hashTagIds) {
    postData.append("hashTagIds", JSON.stringify(formData.hashTagIds));
  }

  if (formData.imagePost && formData.imagePost.length > 0) {
    formData.imagePost.forEach((file) => {
      postData.append("imagePost", file);
    });
  }

  if (formData.badges) {
    postData.append("badges", JSON.stringify(formData.badges));
  }

  if (formData.badgeId) {
    postData.append("badgeId", String(formData.badgeId));
  }

  try {
    const data = await axiosInstance.post("/api/posts", postData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message || error.message || "Error creating post";
    throw new Error(errorMessage);
  }
};

export default createPost;
